import React, { Fragment, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch } from "store";
import {
  Card,
  CardContent,
  Stack,
  Typography,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useQuery } from "hooks/use-query";
import TransactionStatus from "components/transaction-status";
import { useDebounceEffect } from "ahooks";
import QRcodeReact from "qrcode.react";
import {
  fetchManualSellTransaction,
  saveCustomerBlockchainLink,
} from "service/api";
import {
  errorNotification,
  successNotification,
} from "features/notifications/notificationsSlice";
import { fromUnixTime } from "date-fns";
import * as Yup from "yup";
const schema = () =>
  Yup.object().shape({
    customer_blockchain_link: Yup.string().required("Required"),
  });
const Transaction = () => {
  const router = useNavigate();
  const {
    handleSubmit,
    values,
    handleChange,
    handleBlur,
    errors,
    isSubmitting,
  } = useFormik({
    initialValues: {
      customer_blockchain_link: "",
    },
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: (values, { setSubmitting, setFieldValue }) => {
      setSubmitting(true);
      if (transactionId !== null) {
        saveCustomerBlockchainLink({ transactionId, ...values })
          .then((res) => {
            if (res.result) {
              dispatch(successNotification("Blockchain link saved"));
              router(`/transactions`);
            } else {
              dispatch(errorNotification(res.error));
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        setSubmitting(false);
        dispatch(errorNotification("Transaction ID is null"));
      }
    },
  });

  const query = useQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [transactionId, setTransactionId] = useState<number | null>(null);
  const [transaction, setTransaction] = useState<any>(null);
  useDebounceEffect(
    () => {
      const transactionIdFromQuery = query.get("transactionId");
      if (transactionIdFromQuery) {
        const transactionIdAsNumber = Number(transactionIdFromQuery);
        setTransactionId(transactionIdAsNumber);
        if (transactionIdAsNumber) {
          fetchManualSellTransaction(transactionIdAsNumber).then((tr) => {
            if (tr.result) {
              setTransaction(tr.transaction);
            }
          });
        }
      } else {
        navigate("/");
      }
    },
    [],
    {
      wait: 0,
    }
  );

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Card>
            <CardContent>
              {transaction ? (
                <Stack spacing={2}>
                  <Typography variant="h5" component="h2">
                    Your Order
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography variant="h6" component="h2">
                        Here`s the summary of your order
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        Transaction ID:{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          {transaction.legacy_id}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        Order Type :{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          SELL
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography>Status:</Typography>
                        <TransactionStatus
                          status={transaction.status_all}
                          label={transaction.status_all.toUpperCase()}
                          transactionType="sell_manual"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        {transaction.amount}{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          {transaction.asset.toUpperCase()}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        Created:{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          {fromUnixTime(
                            transaction.created_at / 1000
                          ).toLocaleString()}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        Fiat Amount:{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          {" "}
                          {transaction.transaction_fiat_amount}{" "}
                          {transaction.transaction_fiat_currency.toUpperCase()}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Typography>
                        Crypto Wallet:{" "}
                        <Box component="span" sx={{ color: "success.dark" }}>
                          {" "}
                          {transaction.address}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <QRcodeReact value={transaction.address} size={280} />
                    </Grid>
                  </Grid>
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} lg={8}>
                        <TextField
                          label="Blockchain Link"
                          name="customer_blockchain_link"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.customer_blockchain_link}
                          error={!!errors.customer_blockchain_link}
                          helperText={errors.customer_blockchain_link}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={8}>
                        <LoadingButton
                          variant="contained"
                          fullWidth
                          loading={isSubmitting}
                          type="submit"
                        >
                          Confirm
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  </form>
                </Stack>
              ) : (
                <Typography>Transaction not found</Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </Fragment>
  );
};

export default Transaction;
